<app-page-heading [title]="'administration.global-configuration.list.page-title' | translate"></app-page-heading>

<section class="container summary-panel">
  <div class="row">
    <div class="col-6 col-sm-8">
        <div class="ibox float-e-margins">
            <div class="ibox-title">
                <h2 class="handover-title" [translate]="'administration.global-configuration.list.sub-title'"></h2>
              </div>
            <div class="ibox-content">
              <p [translate]="'administration.global-configuration.list.content'"></p>
            </div>
        </div>
    </div>
    <div class="col-6 col-sm-4">
        <button class="btn btn-primary btn-lg pull-right" (click)="createNewSupportMail()">
            <span class="fa fa-plus"></span> {{'administration.global-configuration.list.buttons.create' | translate}}
        </button>
    </div>
</div>
<div class="row">
  <div class="col-md-12">
      <div class="ibox float-e-margins">
          <div class="ibox-content no-padding">
              <div class="table-responsive">
                  <table class="table table-striped">
                      <thead>
                      <tr>
                          <th [translate]="'administration.global-configuration.table.email'" class="force-text-left"></th>
                          <th [translate]="'administration.global-configuration.table.actions'"></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr *ngFor="let gc of globalConfigurations">
                          <td class="force-text-left">
                              <span *ngIf="currentConfiguration !== gc.id">{{ gc.serviceEmail }}</span>
                              <input *ngIf="currentConfiguration === gc.id" [(ngModel)]="gc.serviceEmail" class="form-control" type="text"/>
                          </td>
                          <td>
                              <button *ngIf="editButtonDisplay || currentConfiguration !== gc.id" class="btn btn-outline-secondary btn-sm" (click)="updateServiceEmail(gc.id)">
                                  <i class="fa fa-edit"></i>
                              </button>
                              <button *ngIf="saveButtonDisplay  && currentConfiguration === gc.id" class="btn btn-outline-secondary btn-sm" (click)="saveServiceEmail(gc)" [disabled]="!gc.serviceEmail">
                                  <i class="fa fa-check-circle"></i>
                              </button>
                              <button *ngIf="deleteButtonDisplay  && currentConfiguration === gc.id" class="btn btn-outline-secondary btn-sm" (click)="deleteServiceEmail(deleteModal, gc.id)">
                                  <i class="fa fa-trash"></i>
                              </button>
                          </td>
                      </tr>
                      <tr *ngIf="!globalConfigurations || globalConfigurations.length === 0">
                          <td [attr.colspan]="4" class="force-text-center">
                              <em [translate]="'administration.global-configuration.table.no-email'">
                              </em>
                          </td>
                      </tr>
                      </tbody>
                  </table>
                  <app-pagination [items]="globalConfigurations" [(pageItems)]="pageGlobalConfigurations"></app-pagination>
              </div>
          </div>
      </div>
  </div>
</div>

</section>

<ng-template #deleteModal let-c="close" let-d="dismiss">
    Are you sure you want to delete this global configuration ?
</ng-template>
